import { Component, OnInit, Inject } from '@angular/core';
import { NegativeFeedbackDialogComponent } from '../negative-feedback-dialog/negative-feedback-dialog.component';
import { FeedbackService } from '../../services/feedback.service';
import { TrackingService } from 'src/app/modules/shared/services/tracking.service';
import * as fromEvents from '../../tracking/events';
import { MAT_SNACK_BAR_DATA, MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-feedback-panel',
    templateUrl: './feedback-panel.component.html',
    styleUrls: ['./feedback-panel.component.scss'],
    standalone: false
})
export class FeedbackPanelComponent implements OnInit {
  willCloseTimer: ReturnType<typeof setTimeout>;

  constructor(
    private ref: MatSnackBarRef<void>,
    private dialog: MatDialog,
    private feedback: FeedbackService,
    private tracking: TrackingService,
    @Inject(MAT_SNACK_BAR_DATA) private data: { reportToken?: string },
  ) {
    tracking.track(fromEvents.feedbackDisplayed());
    ref.afterDismissed().subscribe(result => {
      if (!result.dismissedByAction) {
        this.tracking.track(fromEvents.feedbackDismissed({ method: 'timeout' }));
      }
    });
  }

  ratedPositive: boolean = false;
  ratedNegative: boolean = false;

  ngOnInit(): void {}

  static open(snackbar: MatSnackBar, reportToken?: string) {
    return snackbar.openFromComponent(FeedbackPanelComponent, {
      duration: 600 * 1000,
      panelClass: 'feedback-snackbar',
      data: { reportToken },
    });
  }

  onRate($event: number) {
    const score = $event;
    if (score >= 4) {
      this.ratedPositive = true;
      this.willCloseTimer = setTimeout(() => {
        this.ref.dismissWithAction();
      }, 1500);
      this.feedback.sendFeedback(score, [], this.data.reportToken).subscribe();
    } else {
      this.ratedNegative = true;
      this.ref.dismissWithAction();
      NegativeFeedbackDialogComponent.open(this.dialog)
        .afterClosed()
        .subscribe(issues => {
          this.feedback.sendFeedback(score, issues || [], this.data.reportToken).subscribe();
        });
    }
    this.tracking.track(fromEvents.feedbackGiven({ score }));
    this.ref.afterDismissed().subscribe(() => {
      clearTimeout(this.willCloseTimer);
    });
  }

  askMeLater() {
    this.ref.dismissWithAction();
    this.tracking.track(fromEvents.feedbackDismissed({ method: 'explicit' }));
    this.feedback.postpone();
  }
}
